/** A store that bills a subscription itself: MuseFlow can neither cancel nor change it. */
export type StoreProvider = 'apple' | 'google';

interface StoreSubscriptionDetails {
  storeName: string;
  whereToManage: string;
  manageUrl: string;
  manageLinkLabel: string;
}

export const STORE_SUBSCRIPTIONS: Record<StoreProvider, StoreSubscriptionDetails> = {
  apple: {
    storeName: 'Apple',
    whereToManage:
      'To cancel or change it, open Settings on your iPhone or iPad, tap your name, then Subscriptions.',
    manageUrl: 'https://apps.apple.com/account/subscriptions',
    manageLinkLabel: 'Manage your Apple subscription',
  },
  google: {
    storeName: 'Google Play',
    whereToManage:
      'To cancel or change it, open the Google Play app, tap your profile picture, then Payments and subscriptions, then Subscriptions.',
    manageUrl: 'https://play.google.com/store/account/subscriptions',
    manageLinkLabel: 'Manage your Google Play subscription',
  },
};

/** The store that bills this account's subscription, or null when no store does. */
export const storeProviderOf = (
  subscriptionProvider: string | null | undefined,
): StoreProvider | null =>
  subscriptionProvider === 'apple' || subscriptionProvider === 'google'
    ? subscriptionProvider
    : null;

/**
 * The store named by the server when it refuses to cancel or re-activate a
 * subscription it does not bill (HTTP 409), or null when the text names neither.
 */
export const storeProviderNamedIn = (
  refusalMessage: string | null | undefined,
): StoreProvider | null => {
  const text = (refusalMessage ?? '').toLowerCase();
  if (text.includes('google play')) return 'google';
  if (text.includes('apple')) return 'apple';
  return null;
};
